<template>
  <v-card flat class="orders__invoice">
    <v-stepper vertical flat class="transparent" style="direction: ltr">
      <v-stepper-step
        v-for="(status, index) in item.statuses"
        :key="index"
        step="1"
        icon="mdi-pencil"
        :complete="status.active"
      >
        <template #icon>
          <v-icon>mdi-plus</v-icon>
        </template>
        <div class="d-flex justify-center flex-column">
          <span class="secondary--text">{{ status.name }}</span>

          <span class="secondary--text pt-2" v-if="status.activated_at">
            {{ convertDate(status.activated_at) }}
          </span>
        </div>
      </v-stepper-step>
    </v-stepper>
  </v-card>
</template>

<script>
export default {
  name: "OrderStatus",
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      el: 1
    };
  },
  mounted() {
    document.querySelectorAll(".v-stepper__step__step").forEach(el => {
      el.textContent = "";
    });
  }
};
</script>
